export const isEmptyFilterValue = (value: unknown): boolean => {
    if (Array.isArray(value)) {
        return value.length === 0;
    }
    return value === undefined || value === null || value === '';
};
